import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { SectionHeading } from '../ui/SectionHeading';
import { CtaButton } from '../ui/CtaButton';
import { withPlan, withoutPlan } from '../../data/comparison';
import { DELIVERY_NOTE } from '../../data/site';
export function FinalComparison() {
  return <section aria-labelledby="final-title" className="bg-deepest py-14 text-white sm:py-20 lg:py-24" data-id="element-171" data-mp="3f0d81g7rhyti">
      <div className="mx-auto max-w-page px-5 lg:px-8" data-id="element-172" data-mp="2rasmcpk84ngj">
        <SectionHeading id="final-title" eyebrow="Your choice" lead="Your next badminton unit:" highlight="two ways to start" data-id="element-173" data-mp="2mamsd2qheova" />

        <div className="mx-auto mt-10 grid max-w-4xl gap-4 sm:mt-12 sm:gap-5 md:grid-cols-2" data-id="element-174" data-mp="308bcu9gmztzt">
          <div className="rounded-xl border border-white/15 bg-ink/40 p-6 sm:p-8" data-id="element-175" data-mp="2w7j3lg7rlp3j">
            <h3 className="font-display text-[26px] font-bold uppercase leading-none text-white/90" data-id="element-176" data-mp="filyrynrcc86">Without a plan</h3>
            <ul className="mt-6 space-y-3.5" data-id="element-177" data-mp="bko9ywxwfs5b">
              {withoutPlan.map(item => <li key={item} className="flex gap-3 text-base text-white/80" data-id="element-178" data-mp="2uxd2yu5wxllj">
                  <span aria-hidden="true" className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border-2 border-alert text-alert" data-id="element-179" data-mp="2zveij544r2s9">
                    <XIcon className="h-3.5 w-3.5" strokeWidth={3} data-id="element-180" data-mp="38x5ng7quj5l2" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="rounded-xl border-2 border-gold bg-pine p-6 sm:p-8" data-id="element-181" data-mp="2g8qbxv6xb5eh">
            <h3 className="font-display text-[26px] font-bold uppercase leading-none text-gold" data-id="element-182" data-mp="2g6nnvgpbzmce">With Badminton Class Ready</h3>
            <ul className="mt-6 space-y-3.5" data-id="element-183" data-mp="2py9v71yjt19v">
              {withPlan.map(item => <li key={item} className="flex gap-3 text-base font-medium text-white" data-id="element-184" data-mp="1sj5rf7v4g033">
                  <span aria-hidden="true" className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-go text-ink" data-id="element-185" data-mp="1shbgmmdkdocq">
                    <CheckIcon className="h-3.5 w-3.5" strokeWidth={3.5} data-id="element-186" data-mp="30scxvhmnt2kg" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div id="final-cta" className="mx-auto mt-10 max-w-[576px] sm:mt-14 rounded-xl border border-white/15 bg-forest p-6 text-center sm:p-10" data-id="element-187" data-mp="39kex5ckzsct5">
          <p className="text-[13px] font-bold uppercase tracking-[0.16em] text-gold" data-id="element-188" data-mp="35lzbpd4k7chu">Lesson plans + 5 bonuses</p>
          <p className="mt-3 font-display font-bold leading-none" data-id="element-189" data-mp="2cv7au2cjtzo6">
            <span className="text-[80px] sm:text-[96px]" data-id="element-190" data-mp="2cx1w5hrqftss">$27</span>
            <span className="ml-2 align-top text-[26px]" data-id="element-191" data-mp="2qv8ka66vqff9">USD</span>
          </p>
          <p className="mt-2 text-[13px] font-bold uppercase tracking-[0.16em] text-white/80" data-id="element-192" data-mp="2lvdw4aeho3xw">One-time purchase</p>
          <CtaButton target="offer" size="xl" className="mt-8 w-full" data-id="element-193" data-mp="63ydmbb8xose">
            See the offer
          </CtaButton>
          <p className="mt-6 text-base text-white/80" data-id="element-194" data-mp="14v8kqv9nikf">{DELIVERY_NOTE}</p>
        </div>
      </div>
    </section>;
}